import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20Asian%20digital%20cityscape%20with%20flowing%20data%20streams%20and%20warm%20coral%20and%20gold%20color%20gradients%2C%20futuristic%20skyline%20blending%20Tokyo%20Shanghai%20and%20Seoul%20landmarks%2C%20clean%20minimalist%20composition%20with%20abstract%20geometric%20patterns%2C%20luminous%20atmosphere%2C%20digital%20art%20style&width=1600&height=900&seq=hero-asia-online&orientation=landscape"
        alt="亚洲在线 - 亚洲数字内容与服务一站式平台"
        title="亚洲在线数字生活平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            连接亚洲
            <span className="block text-primary-300">精彩在线</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚亚洲顶级数字内容、娱乐资讯与在线服务，覆盖东亚、东南亚、南亚全域。
            一站式探索亚洲数字生活的无限可能。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/entertainment"
              className="px-8 py-3 bg-primary-500 text-white rounded-lg font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              探索内容
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-lg font-medium text-sm hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}